import { render, staticRenderFns } from "./send-notifications.vue?vue&type=template&id=55dc9028"
import script from "./send-notifications.vue?vue&type=script&lang=js"
export * from "./send-notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports